import $ from 'jquery';

$('.cb.expand-collapse-button').click(function () {
  const id = $(this).attr("id")
  const topSection = $(`#college-board-toggle-top-section-${id}`);
  const bottomSection = $(`#college-board-toggle-bottom-section-${id}`);
  if(topSection.hasClass('closed')) {
    topSection.removeClass('closed')
    topSection.addClass('open')
    bottomSection.removeClass('hidden')
  } else {
    topSection.removeClass('open')
    topSection.addClass('closed')
    bottomSection.addClass('hidden')
  }
});

$('.q-and-a-question-button').on('click keydown', function (e) {
  if (e.type === 'keydown' && e.key !== 'Enter') { return; }

  const questionButtonId = $(this).attr("id");
  const answerSectionId = questionButtonId.replace('-question-', '-q-and-a-answer-section-');
  const answerSection = $('#' + answerSectionId);

  if (answerSection.hasClass('show')) {
    answerSection.removeClass('show').addClass('hide');
  } else {
    answerSection.removeClass('hide').addClass('show');
  }
});

$('.q-and-a.expand-collapse-button').click(function () {
  const expandButtonId = $(this).attr("id");
  const answerSectionId = expandButtonId.replace('expand-collapse', 'q-and-a-answer-section');
  const answerSection = $('#' + answerSectionId);

  const innerTextElement = $(this).children('p').eq(0);
  const innerImgElement = $(this).children('img').eq(0);
  const expandSrc = 'https://assets.quill.org/images/shared/expand.svg';
  const collapseSrc = 'https://assets.quill.org/images/shared/collapse.svg';

  // A flag to detect if we're expanding
  let isExpanding = false;

  if (answerSection.hasClass('show') && innerTextElement.length !== 0) {
    innerTextElement.text('Expand');
    answerSection.removeClass('show').addClass('hide').attr('aria-hidden', 'true');
  } else if (answerSection.hasClass('show') && innerImgElement.length !== 0) {
    innerImgElement.attr('src', expandSrc);
    answerSection.removeClass('show').addClass('hide').attr('aria-hidden', 'true');
  } else if (answerSection.hasClass('hide') && innerTextElement.length !== 0) {
    innerTextElement.text('Collapse');
    answerSection.removeClass('hide').addClass('show').attr('aria-hidden', 'false');
    isExpanding = true;
  } else if (answerSection.hasClass('hide') && innerImgElement.length !== 0) {
    innerImgElement.attr('src', collapseSrc);
    answerSection.removeClass('hide').addClass('show').attr('aria-hidden', 'false');
    isExpanding = true;
  }

  // If we just expanded the answer section, move focus to its first link
  if (isExpanding) {
    // A slight delay may be necessary for the content to become visible
    setTimeout(function () {
      const firstLink = answerSection.find('a').first();
      if (firstLink.length) {
        firstLink.focus();
      }
    }, 100);
  }
});

